import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { trackCallConversion } from '../../utils/tracking';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer-section">
      {/* Background Ambient Glow */}
      <div className="footer-bg-glow" aria-hidden="true" />

      <div className="footer-container">
        <div className="footer-main">
          {/* Brand & Socials Column */}
          <div className="footer-brand">
            <div className="footer-logo-row">
              <img
                src="/dmsr_logo_new.png"
                alt="DSMR Solutions Logo"
                className="footer-logo-icon"
                onError={(e) => {
                  e.target.style.display = 'none';
                  const sibling = e.target.nextElementSibling;
                  if (sibling) sibling.style.display = 'block';
                }}
              />
              <span className="footer-logo-fallback-text" style={{ display: 'none' }}>
                DSMR <span className="footer-logo-gold">Solutions</span>
              </span>
            </div>

            <p className="footer-desc">
              Premium doorstep solutions for your devices, gadgets, and personal tech. Fast, reliable, and professional support delivered to your door.
            </p>

            <div className="footer-independent-note">
              Independent Repair Service • Not affiliated with any brand
            </div>

            <div className="footer-socials">
              <a href="#" aria-label="Facebook" className="footer-social-icon"><FaFacebook /></a>
              <a href="#" aria-label="Twitter" className="footer-social-icon"><FaTwitter /></a>
              <a href="#" aria-label="Instagram" className="footer-social-icon"><FaInstagram /></a>
              <a href="#" aria-label="LinkedIn" className="footer-social-icon"><FaLinkedin /></a>
            </div>
          </div>

          {/* Links Column */}
          <div className="footer-links">
            <div className="footer-col">
              <div className="footer-col-title">Quick Links</div>
              <a href="/" className="footer-link">Home</a>
              <a href="/about" className="footer-link">About Us</a>
              <a href="/#services" className="footer-link">Services</a>
              <a href="/#benefits" className="footer-link">Why Us</a>
              <a href="/data-recovery" className="footer-link">Data Recovery</a>
            </div>

            <div className="footer-col">
              <div className="footer-col-title">Our Services</div>
              <a href="/macbook-repair" className="footer-link">MacBook Repair</a>
              <a href="/iphone-repair" className="footer-link">iPhone Repair</a>
              <a href="/laptop-repair-at-home" className="footer-link">Laptop</a>
              <a href="/#services" className="footer-link">Smartphone</a>
              <a href="/#services" className="footer-link">Desktop PC</a>
              <a href="/#services" className="footer-link">Tablet</a>
            </div>

            <div className="footer-col">
              <div className="footer-col-title">Support</div>
              <a href="/#faq" className="footer-link">FAQs</a>
              <a href="https://wa.me/918700319769" className="footer-link">Contact Us</a>
              <a href="/refund-cancellation-policy" className="footer-link">Refund & Cancellation Policy</a>
              <a href="/warranty-policy" className="footer-link">Warranty Policy</a>
              <a href="/terms-of-service" className="footer-link">Terms of Service</a>
            </div>
          </div>

          {/* Contact Column */}
          <div className="footer-contact">
            <div className="footer-col-title">Contact Us</div>

            <div className="footer-contact-row">
              <span className="footer-contact-icon" role="img" aria-label="phone">📞</span>
              <div className="footer-contact-details">
                <span className="footer-contact-label">Phone</span>
                <a
                  href="tel:+918700319769"
                  className="footer-contact-val"
                  data-dsmr-phone="true"
                  onClick={(e) => trackCallConversion(e, "tel:+918700319769")}
                >
                  +91 8700319769
                </a>
              </div>
            </div>

            <div className="footer-contact-row">
              <span className="footer-contact-icon" role="img" aria-label="email">✉️</span>
              <div className="footer-contact-details">
                <span className="footer-contact-label">Email</span>
                <a href="mailto:support@dsmrsolutions.in" className="footer-contact-val">support@dsmrsolutions.in</a>
              </div>
            </div>

            <div className="footer-contact-row">
              <span className="footer-contact-icon" role="img" aria-label="address">📍</span>
              <div className="footer-contact-details">
                <span className="footer-contact-label">Address</span>
                <span className="footer-contact-val">Delhi, India - 110019</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Copyright & Policy Links Bar */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            © {new Date().getFullYear()} DSMR Solutions. Made with <span className="footer-heart" role="img" aria-label="love">❤️</span> in India
          </div>
          <div className="footer-bottom-links">
            <a href="/privacy-policy" className="footer-bottom-link">Privacy Policy</a>
            <a href="/disclaimer" className="footer-bottom-link">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
